import * as React from "react";
import NewButton from "../uiMerge/newButton";
import { NewModal } from "../uiMerge/newModal";
import ConnectIdIcon from "../../assets/images/ConnectIdNew.svg";
import { useNavigate } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
type ConnectIdModalProps = {
  visible: boolean;
  onCancel: () => void;
  onOk: () => void;
};

export const ConnectIdModal: React.FC<ConnectIdModalProps> = ({
  visible,
  onCancel,
  onOk,
}) => {
  
  const navigate = useNavigate();
  return (
    <NewModal
      isOpen={visible}
      colorClass="bg-[#1E1E1E]"
      roundedClass="rounded-2xl"
      widthClass="w-[350px]"
      showCloseButton={false}
      animationClass="grow-in"
      position="center"
      onClose={onCancel}
      onOk={onOk}
    >
      <div className="p-5 text-white flex flex-col min-h-[38vh] justify-center items-center">
        <div className="text-center w-[250px] gap-y-2 flex flex-col justify-center items-center">
          <div className="pb-4">
            <img src={ConnectIdIcon} alt="success" />
          </div>

          <div className="flex flex-col items-center space-y-2">
            <p className="text-2xl font-bold">Connect your ID</p>
            <p className="text-md text-[#CECECF] font-normal">
              Sorry, you have to connect your ID to access benefits.
            </p>
          </div>

          <div className="w-full pt-5 flex flex-col">
            <NewButton variant="outline" fullWidth onClick={() => navigate(ROUTES.CONNECT_ID)}>
              Connect ID
            </NewButton>
          </div>
        </div>
      </div>
    </NewModal>
  );
};